"use strict";

var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optic = exports.Optic = exports.words = exports.chars = exports.appendTo = exports.prependTo = exports.rewrite = exports.reread = exports.partsOf = exports.valueOr = exports.filter = exports.find = exports.guard = exports.optional = exports.atKey = exports.at = exports.when = exports.nth = exports.pick = exports.prop = exports.indexed = exports.collect = exports.preview = exports.get = exports.remove = exports.set = exports.modify = exports.to = exports.elems = exports.lens = exports.iso = exports.eq = exports.compositionType = exports.id = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var id = function id(x) {
  return x;
};
exports.id = id;
var Left = function Left(value) {
  return {
    _tag: 'Left',
    value: value
  };
};
var Right = function Right(value) {
  return {
    _tag: 'Right',
    value: value
  };
};
var either = function either(mapLeft, mapRight, e) {
  return e._tag === 'Left' ? mapLeft(e.value) : mapRight(e.value);
};
var profunctorFn = {
  dimap: function dimap(f, g, fn) {
    return function (x) {
      return g(fn(f(x)));
    };
  },
  first: function first(f) {
    return function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        x = _ref3[0],
        y = _ref3[1];
      return [f(x), y];
    };
  },
  right: function right(f) {
    return function (e) {
      return e._tag === 'Left' ? e : Right(f(e.value));
    };
  },
  wander: function wander(f) {
    return function (xs) {
      return xs.map(f);
    };
  }
};
var monoidFirst = {
  empty: function empty() {
    return undefined;
  },
  foldMap: function foldMap(f, xs) {
    for (var i = 0; i < xs.length; i++) {
      var x = f(xs[i]);
      if (x != undefined) return x;
    }
    return undefined;
  }
};
var monoidArray = {
  empty: function empty() {
    return [];
  },
  foldMap: function foldMap(f, xs) {
    var acc = [];
    xs.forEach(function (x) {
      acc = acc.concat(f(x));
    });
    return acc;
  }
};
var profunctorConst = function profunctorConst(monoid) {
  return {
    dimap: function dimap(f, _g, toF) {
      return function (x) {
        return toF(f(x));
      };
    },
    first: function first(toF) {
      return function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          x = _ref5[0],
          _y = _ref5[1];
        return toF(x);
      };
    },
    right: function right(toF) {
      return function (e) {
        return e._tag === 'Left' ? monoid.empty() : toF(e.value);
      };
    },
    wander: function wander(toF) {
      return function (xs) {
        return monoid.foldMap(toF, xs);
      };
    }
  };
};
exports.compositionType = {
  Equivalence: {
    Equivalence: 'Equivalence',
    Iso: 'Iso',
    Lens: 'Lens',
    Prism: 'Prism',
    Traversal: 'Traversal',
    Getter: 'Getter',
    AffineFold: 'AffineFold',
    Fold: 'Fold',
    Setter: 'Setter'
  },
  Iso: {
    Equivalence: 'Iso',
    Iso: 'Iso',
    Lens: 'Lens',
    Prism: 'Prism',
    Traversal: 'Traversal',
    Getter: 'Getter',
    AffineFold: 'AffineFold',
    Fold: 'Fold',
    Setter: 'Setter'
  },
  Lens: {
    Equivalence: 'Lens',
    Iso: 'Lens',
    Lens: 'Lens',
    Prism: 'Prism',
    Traversal: 'Traversal',
    Getter: 'Getter',
    AffineFold: 'AffineFold',
    Fold: 'Fold',
    Setter: 'Setter'
  },
  Prism: {
    Equivalence: 'Prism',
    Iso: 'Prism',
    Lens: 'Prism',
    Prism: 'Prism',
    Traversal: 'Traversal',
    Getter: 'AffineFold',
    AffineFold: 'AffineFold',
    Fold: 'Fold',
    Setter: 'Setter'
  },
  Traversal: {
    Equivalence: 'Traversal',
    Iso: 'Traversal',
    Lens: 'Traversal',
    Prism: 'Traversal',
    Traversal: 'Traversal',
    Getter: 'Fold',
    AffineFold: 'Fold',
    Fold: 'Fold',
    Setter: 'Setter'
  },
  Getter: {
    Equivalence: 'Getter',
    Iso: 'Getter',
    Lens: 'Getter',
    Prism: 'AffineFold',
    Traversal: 'Fold',
    Getter: 'Getter',
    AffineFold: 'AffineFold',
    Fold: 'Fold',
    Setter: undefined
  },
  AffineFold: {
    Equivalence: 'AffineFold',
    Iso: 'AffineFold',
    Lens: 'AffineFold',
    Prism: 'AffineFold',
    Traversal: 'Fold',
    Getter: 'AffineFold',
    AffineFold: 'AffineFold',
    Fold: 'Fold',
    Setter: undefined
  },
  Fold: {
    Equivalence: 'Fold',
    Iso: 'Fold',
    Lens: 'Fold',
    Prism: 'Fold',
    Traversal: 'Fold',
    Getter: 'Fold',
    AffineFold: 'Fold',
    Fold: 'Fold',
    Setter: undefined
  },
  Setter: {
    Equivalence: undefined,
    Iso: undefined,
    Lens: undefined,
    Prism: undefined,
    Traversal: undefined,
    Getter: undefined,
    AffineFold: undefined,
    Fold: undefined,
    Setter: undefined
  }
};
var withTag = function withTag(tag, optic) {
  var result = optic;
  result._tag = tag;
  return result;
};
var removable = function removable(optic) {
  optic._removable = true;
  return optic;
};
function _compose(optic1, optic2, optic3) {
  switch (arguments.length) {
    case 2:
      {
        var next = function next(P, optic) {
          return optic1(P, optic2(P, optic));
        };
        next._tag = exports.compositionType[optic1._tag][optic2._tag];
        next._removable = optic2._removable || false;
        return next;
      }
    default:
      {
        var tag1 = exports.compositionType[optic1._tag][optic2._tag];
        var _next = function _next(P, optic) {
          return optic1(P, optic2(P, optic3(P, optic)));
        };
        _next._tag = exports.compositionType[tag1][optic3._tag];
        _next._removable = optic3._removable || false;
        return _next;
      }
  }
}
exports.eq = withTag('Equivalence', function (_P, optic) {
  return optic;
});
var iso = function iso(there, back) {
  return withTag('Iso', function (P, optic) {
    return P.dimap(there, back, optic);
  });
};
exports.iso = iso;
var lens = function lens(view, update) {
  return withTag('Lens', function (P, optic) {
    return P.dimap(function (x) {
      return [view(x), x];
    }, update, P.first(optic));
  });
};
exports.lens = lens;
var prism = function prism(match, build) {
  return withTag('Prism', function (P, optic) {
    return P.dimap(match, function (x) {
      return either(exports.id, build, x);
    }, P.right(optic));
  });
};
exports.elems = withTag('Traversal', function (P, optic) {
  return P.dimap(exports.id, exports.id, P.wander(optic));
});
var to = function to(fn) {
  return withTag('Getter', function (P, optic) {
    return P.dimap(fn, exports.id, optic);
  });
};
exports.to = to;
/////////////////////////////////////////////////////////////////////////////
var modify = function modify(optic, fn, source) {
  return optic(profunctorFn, fn)(source);
};
exports.modify = modify;
var set = function set(optic, value, source) {
  return optic(profunctorFn, function () {
    return value;
  })(source);
};
exports.set = set;
var remove = function remove(optic, source) {
  return (0, exports.set)(optic, removeMe, source);
};
exports.remove = remove;
var get = function get(optic, source) {
  return optic(profunctorConst({}), exports.id)(source);
};
exports.get = get;
var preview = function preview(optic, source) {
  return optic(profunctorConst(monoidFirst), exports.id)(source);
};
exports.preview = preview;
var collect = function collect(optic, source) {
  return optic(profunctorConst(monoidArray), function (x) {
    return [x];
  })(source);
};
exports.collect = collect;
/////////////////////////////////////////////////////////////////////////////
exports.indexed = (0, exports.iso)(function (value) {
  return value.map(function (v, k) {
    return [k, v];
  });
}, function (value) {
  var sorted = _toConsumableArray(value).sort(function (a, b) {
    return a[0] - b[0];
  });
  var result = [];
  for (var i = 0; i < sorted.length; ++i) {
    if (i === sorted.length - 1 || sorted[i][0] !== sorted[i + 1][0]) {
      result.push(sorted[i][1]);
    }
  }
  return result;
});
var prop = function prop(key) {
  return (0, exports.lens)(function (source) {
    return source[key];
  }, function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      value = _ref7[0],
      source = _ref7[1];
    return Object.assign(Object.assign({}, source), _defineProperty({}, key, value));
  });
};
exports.prop = prop;
var pick = function pick(keys) {
  return (0, exports.lens)(function (source) {
    var value = {};
    var _iterator = _createForOfIteratorHelper(keys),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        value[key] = source[key];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return value;
  }, function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      value = _ref9[0],
      source = _ref9[1];
    var result = Object.assign({}, source);
    var _iterator2 = _createForOfIteratorHelper(keys),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;
        delete result[key];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return Object.assign(result, value);
  });
};
exports.pick = pick;
var nth = function nth(n) {
  return (0, exports.lens)(function (value) {
    return value[n];
  }, function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      value = _ref11[0],
      source = _ref11[1];
    var result = source.slice();
    result[n] = value;
    return result;
  });
};
exports.nth = nth;
var fst = /* @__PURE__ */(0, exports.nth)(0);
var when = function when(pred) {
  return prism(function (x) {
    return pred(x) ? Right(x) : Left(x);
  }, exports.id);
};
exports.when = when;
var noMatch = /* @__PURE__ */Symbol('__no_match__');
var mustMatch = /* @__PURE__ */(0, exports.when)(function (source) {
  return source !== noMatch;
});
var removeMe = /* @__PURE__ */Symbol('__remove_me__');
var at = function at(i) {
  return removable(_compose((0, exports.lens)(function (source) {
    return 0 <= i && i < source.length ? source[i] : noMatch;
  }, function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      value = _ref13[0],
      source = _ref13[1];
    if (value === noMatch) {
      return source;
    }
    if (value === removeMe) {
      if (typeof source === 'string') {
        return source.substring(0, i) + source.substring(i + 1);
      } else {
        return [].concat(_toConsumableArray(source.slice(0, i)), _toConsumableArray(source.slice(i + 1)));
      }
    }
    if (typeof source === 'string') {
      if (i === 0) {
        return value + source.substring(1);
      }
      if (i === source.length) {
        return source.substring(0, i - 1) + value;
      }
      return source.substring(0, i) + value + source.substring(i + 1);
    } else {
      var result = source.slice();
      result[i] = value;
      return result;
    }
  }), mustMatch));
};
exports.at = at;
var atKey = function atKey(key) {
  return removable(_compose((0, exports.lens)(function (source) {
    var value = source[key];
    return value !== undefined ? value : noMatch;
  }, function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
      value = _ref15[0],
      source = _ref15[1];
    if (value === noMatch) {
      return source;
    }
    if (value === removeMe) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = source,
        _b = key,
        _ = _a[_b],
        rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
      return rest;
    }
    return Object.assign(Object.assign({}, source), _defineProperty({}, key, value));
  }), mustMatch));
};
exports.atKey = atKey;
exports.optional = prism(function (source) {
  return source === undefined ? Left(undefined) : Right(source);
}, exports.id);
var guard = function guard(fn) {
  return prism(function (source) {
    return fn(source) ? Right(source) : Left(source);
  }, exports.id);
};
exports.guard = guard;
var find = function find(predicate) {
  return removable(_compose((0, exports.lens)(function (source) {
    var index = source.findIndex(predicate);
    if (index === -1) {
      return [noMatch, -1];
    }
    return [source[index], index];
  }, function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
      _ref17$ = _slicedToArray(_ref17[0], 2),
      value = _ref17$[0],
      index = _ref17$[1],
      source = _ref17[1];
    if (value === noMatch) {
      return source;
    }
    if (value === removeMe) {
      return [].concat(_toConsumableArray(source.slice(0, index)), _toConsumableArray(source.slice(index + 1)));
    }
    var result = source.slice();
    result[index] = value;
    return result;
  }), fst, mustMatch));
};
exports.find = find;
var filter = function filter(predicate) {
  return _compose((0, exports.lens)(function (source) {
    var indexes = source.map(function (item, index) {
      return predicate(item) ? index : null;
    }).filter(function (index) {
      return index != null;
    });
    return [indexes.map(function (index) {
      return source[index];
    }), indexes];
  }, function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
      _ref19$ = _slicedToArray(_ref19[0], 2),
      values = _ref19$[0],
      indexes = _ref19$[1],
      source = _ref19[1];
    var sn = source.length,
      vn = values.length;
    var si = 0,
      ii = 0,
      vi = 0;
    var result = [];
    while (si < sn) {
      if (indexes[ii] === si) {
        ++ii;
        if (vi < vn) {
          result.push(values[vi]);
          ++vi;
        }
      } else {
        result.push(source[si]);
      }
      ++si;
    }
    while (vi < vn) {
      result.push(values[vi++]);
    }
    return result;
  }), fst);
};
exports.filter = filter;
var valueOr = function valueOr(defaultValue) {
  return (0, exports.lens)(function (source) {
    return source === undefined ? defaultValue : source;
  }, function (_ref20) {
    var _ref21 = _slicedToArray(_ref20, 2),
      value = _ref21[0],
      _source = _ref21[1];
    return value;
  });
};
exports.valueOr = valueOr;
var partsOf = function partsOf(traversal) {
  return _compose((0, exports.lens)(function (source) {
    var value = (0, exports.collect)(traversal, source);
    return [value, value.length];
  }, function (_ref22) {
    var _ref23 = _slicedToArray(_ref22, 2),
      _ref23$ = _slicedToArray(_ref23[0], 2),
      value = _ref23$[0],
      originalLength = _ref23$[1],
      source = _ref23[1];
    if (value.length !== originalLength) {
      throw new Error('cannot add/remove elements through partsOf');
    }
    var i = 0;
    return (0, exports.modify)(traversal, function () {
      return value[i++];
    }, source);
  }), fst);
};
exports.partsOf = partsOf;
var reread = function reread(fn) {
  return (0, exports.lens)(function (source) {
    return fn(source);
  }, function (_ref24) {
    var _ref25 = _slicedToArray(_ref24, 2),
      value = _ref25[0],
      _ = _ref25[1];
    return value;
  });
};
exports.reread = reread;
var rewrite = function rewrite(fn) {
  return (0, exports.lens)(function (source) {
    return source;
  }, function (_ref26) {
    var _ref27 = _slicedToArray(_ref26, 2),
      value = _ref27[0],
      _ = _ref27[1];
    return fn(value);
  });
};
exports.rewrite = rewrite;
exports.prependTo = (0, exports.lens)(function (_source) {
  return undefined;
}, function (_ref28) {
  var _ref29 = _slicedToArray(_ref28, 2),
    value = _ref29[0],
    source = _ref29[1];
  if (value === undefined) return source;
  return [value].concat(_toConsumableArray(source));
});
exports.appendTo = (0, exports.lens)(function (_source) {
  return undefined;
}, function (_ref30) {
  var _ref31 = _slicedToArray(_ref30, 2),
    value = _ref31[0],
    source = _ref31[1];
  if (value === undefined) return source;
  return [].concat(_toConsumableArray(source), [value]);
});
exports.chars = _compose((0, exports.iso)(function (s) {
  return s.split('');
}, function (a) {
  return a.join('');
}), exports.elems);
exports.words = _compose((0, exports.iso)(function (s) {
  return s.split(/\b/);
}, function (a) {
  return a.join('');
}), exports.elems, (0, exports.when)(function (s) {
  return !/\s+/.test(s);
}));
/////////////////////////////////////////////////////////////////////////////
var Optic = /*#__PURE__*/function () {
  function Optic(_ref) {
    _classCallCheck(this, Optic);
    this._ref = _ref;
  }
  _createClass(Optic, [{
    key: "compose",
    value: function compose(other) {
      return new Optic(_compose(this._ref, other._ref));
    }
  }, {
    key: "iso",
    value: function iso(there, back) {
      return new Optic(_compose(this._ref, (0, exports.iso)(there, back)));
    }
  }, {
    key: "lens",
    value: function lens(view, set) {
      return new Optic(_compose(this._ref, (0, exports.lens)(view, function (_ref32) {
        var _ref33 = _slicedToArray(_ref32, 2),
          value = _ref33[0],
          source = _ref33[1];
        return set(source, value);
      })));
    }
  }, {
    key: "indexed",
    value: function indexed() {
      return new Optic(_compose(this._ref, exports.indexed));
    }
  }, {
    key: "prop",
    value: function prop(key) {
      return new Optic(_compose(this._ref, (0, exports.prop)(key)));
    }
  }, {
    key: "path",
    value: function path() {
      for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
      }
      if (keys.length === 1) {
        keys = keys[0].split('.');
      }
      return new Optic(keys.reduce(function (ref, key) {
        return _compose(ref, (0, exports.prop)(key));
      }, this._ref));
    }
  }, {
    key: "pick",
    value: function pick(keys) {
      return new Optic(_compose(this._ref, (0, exports.pick)(keys)));
    }
  }, {
    key: "nth",
    value: function nth(n) {
      return new Optic(_compose(this._ref, (0, exports.nth)(n)));
    }
  }, {
    key: "filter",
    value: function filter(predicate) {
      return new Optic(_compose(this._ref, (0, exports.filter)(predicate)));
    }
  }, {
    key: "valueOr",
    value: function valueOr(defaultValue) {
      return new Optic(_compose(this._ref, (0, exports.valueOr)(defaultValue)));
    }
  }, {
    key: "partsOf",
    value: function partsOf(traversalOrFn) {
      var traversal = typeof traversalOrFn === 'function' ? traversalOrFn(exports.optic) : traversalOrFn;
      return new Optic(_compose(this._ref, (0, exports.partsOf)(traversal._ref)));
    }
  }, {
    key: "reread",
    value: function reread(fn) {
      return new Optic(_compose(this._ref, (0, exports.reread)(fn)));
    }
  }, {
    key: "rewrite",
    value: function rewrite(fn) {
      return new Optic(_compose(this._ref, (0, exports.rewrite)(fn)));
    }
  }, {
    key: "optional",
    value: function optional() {
      return new Optic(_compose(this._ref, exports.optional));
    }
  }, {
    key: "guard_",
    value: function guard_() {
      var _this = this;
      return function (fn) {
        return _this.guard(fn);
      };
    }
  }, {
    key: "guard",
    value: function guard(fn) {
      return new Optic(_compose(this._ref, (0, exports.guard)(fn)));
    }
  }, {
    key: "at",
    value: function at(i) {
      return new Optic(_compose(this._ref, (0, exports.at)(i)));
    }
  }, {
    key: "head",
    value: function head() {
      return new Optic(_compose(this._ref, (0, exports.at)(0)));
    }
  }, {
    key: "index",
    value: function index(i) {
      return new Optic(_compose(this._ref, (0, exports.at)(i)));
    }
  }, {
    key: "find",
    value: function find(predicate) {
      return new Optic(_compose(this._ref, (0, exports.find)(predicate)));
    }
  }, {
    key: "elems",
    value: function elems() {
      return new Optic(_compose(this._ref, exports.elems));
    }
  }, {
    key: "to",
    value: function to(fn) {
      return new Optic(_compose(this._ref, (0, exports.to)(fn)));
    }
  }, {
    key: "when",
    value: function when(predicate) {
      return new Optic(_compose(this._ref, (0, exports.when)(predicate)));
    }
  }, {
    key: "chars",
    value: function chars() {
      return new Optic(_compose(this._ref, exports.chars));
    }
  }, {
    key: "words",
    value: function words() {
      return new Optic(_compose(this._ref, exports.words));
    }
  }, {
    key: "prependTo",
    value: function prependTo() {
      return new Optic(_compose(this._ref, exports.prependTo));
    }
  }, {
    key: "appendTo",
    value: function appendTo() {
      return new Optic(_compose(this._ref, exports.appendTo));
    }
  }, {
    key: "_tag",
    get: function get() {
      return this._ref._tag;
    }
  }, {
    key: "_removable",
    get: function get() {
      return this._ref._removable;
    }
  }]);
  return Optic;
}();
exports.Optic = Optic;
exports.optic = new Optic(exports.eq);